import { render, staticRenderFns } from "./DistrictEdit.vue?vue&type=template&id=3de4efbc&scoped=true&"
import script from "./DistrictEdit.vue?vue&type=script&lang=js&"
export * from "./DistrictEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de4efbc",
  null
  
)

export default component.exports